import React from 'react'
import { Navigate } from 'react-router-dom';
import { isSabAuthenticated } from '../helpers/AuthStatus';

const PrivateRoute = ({ children }) => {
    const isAuthenticated = isSabAuthenticated()
  
    if (!isAuthenticated) return <Navigate to="/" replace />;
    return children;
}

export default PrivateRoute